import React, { useEffect, useState } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';

import { getOperacaoCertificado } from '../../helpers/getOperacaoCertificado';

export default function CadastroCertificadoDialog({ open, onClose, selected, loading = false, onConfirm }) {
    const [dados, setDados] = useState({
        finalidade: 'NFE_DISTRIBUICAO',
        ambiente: 'PRODUCAO',
        senha: '',
        arquivo: null,
    });

    const operacao = getOperacaoCertificado(selected);

    const { funcao, isCadastro, isEdicao, isExclusao } = operacao;

    useEffect(() => {
        if (!open) return;

        setDados({
            finalidade: selected?.finalidade ?? 'NFE_DISTRIBUICAO',

            ambiente: selected?.ambiente ?? 'PRODUCAO',

            senha: '',
            funcao: funcao,
            /*
             * Na edição, o certificado já salvo nunca será
             * carregado novamente no campo de arquivo.
             */
            arquivo: null,
        });
    }, [open, funcao, selected]);

    const handleChange = (event) => {
        const { name, value, files } = event.target;

        setDados((prev) => ({
            ...prev,
            [name]: name === 'arquivo' ? (files?.[0] ?? null) : value,
        }));
    };

    const handleConfirm = () => {
        onConfirm?.({
            ...dados,
            selected,
        });
    };

    return (
        <Dialog open={Boolean(open)} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>{`${funcao} Certificado Digital`}</DialogTitle>

            <DialogContent dividers>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        pt: 1,
                    }}
                >
                    <TextField
                        select
                        fullWidth
                        label="Finalidade"
                        name="finalidade"
                        value={dados.finalidade}
                        onChange={handleChange}
                        disabled={loading}
                    >
                        <MenuItem value="NFE_DISTRIBUICAO">Distribuição DF-e da NF-e</MenuItem>
                    </TextField>

                    <TextField
                        select
                        fullWidth
                        label="Ambiente"
                        name="ambiente"
                        value={dados.ambiente}
                        onChange={handleChange}
                        disabled={loading}
                    >
                        <MenuItem value="PRODUCAO">Produção</MenuItem>

                        <MenuItem value="HOMOLOGACAO">Homologação</MenuItem>
                    </TextField>

                    {!isExclusao && (
                        <TextField
                            fullWidth
                            type="file"
                            name="arquivo"
                            onChange={handleChange}
                            disabled={loading}
                            inputProps={{
                                accept: '.pfx,.p12',
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            label={isEdicao ? 'Novo arquivo do certificado' : 'Arquivo do certificado'}
                        />
                    )}

                    {isEdicao && (
                        <Typography variant="body2" color="text.secondary">
                            Deixe o arquivo vazio para manter o certificado atualmente cadastrado.
                        </Typography>
                    )}

                    {!isExclusao && (
                        <>
                            <TextField
                                fullWidth
                                type="password"
                                label="Senha do certificado"
                                name="senha"
                                value={dados.senha}
                                onChange={handleChange}
                                disabled={loading}
                                autoComplete="new-password"
                            />

                            <Typography variant="caption" color="text.secondary">
                                O arquivo será enviado somente para validação e armazenamento criptografado. O sistema não
                                permitirá download posterior.
                            </Typography>
                        </>
                    )}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="inherit" disabled={loading}>
                    Cancelar
                </Button>

                <Button variant="contained" onClick={handleConfirm} disabled={loading}>
                    {loading ? 'Processando...' : `${funcao}`}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
